module.exports = __webpack_public_path__ + "img/6.9ab8de22.png";